export default __webpack_public_path__ + "static/media/elevate-by-ease.9130817d.png";